import { isTeamsAppEnabled as isTeamsAppEnabledBase } from '@atlaskit/teams-app-config/is-teams-app-enabled';

import { getIsNav4EnabledSafe } from './getIsNav4EnabledSafe';

export const isTeamsAppEnabled = (): boolean => {
	return isTeamsAppEnabledBase({
		userHasNav4Enabled: getIsNav4EnabledSafe(),
		hostProduct: 'confluence',
	});
};
